export const hasBillPayAccess = ({ billPay, userRole } = {}) =>
  Boolean(billPay) && userRole === 'internal'
